<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="notFound">
  <div class="modal-header">
    <h4 class="modal-title">Request to join Association Not Found</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!(serverError || notFound)">

  <div class="modal-header">
    <h4 class="modal-title">Review Request to join Association</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!loadingAssociationMember && !loadingAssociation">

    <div class="alert alert-info" role="alert" *ngIf="association.verification_requirements">
      {{ association.verification_requirements }}
    </div>

    <table>
      <tr>
        <td class="pr-3 align-text-top" style="min-width: 145px;">Association Name:</td>
        <td>{{ associationMember.association_name }}</td>
      </tr>
      <tr>
        <td class="pr-3 align-text-top">Customer Name:</td>
        <td>
          <a [routerLink]="['/customers', associationMember.customer_id.toString()]" target="_blank">
            {{ associationMember.customer_first_name }} {{ associationMember.customer_last_name }}
          </a>
        </td>
      </tr>
      <tr>
        <td class="pr-3 align-text-top">Birthday:</td>
        <td>{{ dateStringFromISO8601(associationMember.customer_birthday) }}</td>
      </tr>
      <tr>
        <td class="pr-3 align-text-top">Request Created At:</td>
        <td>
          {{ timeStringFromISO8601(associationMember.created_at) }},
          {{ dateStringFromISO8601(associationMember.created_at) }}
        </td>
      </tr>
      <tr>
        <td class="pr-3 align-text-top">Request Document:</td>
        <td>
          <ng-container *ngIf="associationMember.application_document !== null">
            <a [href]="associationMember.application_document"
               target="_blank">
              <img [src]="associationMember.application_document"
                   alt="Request document image"
                   style="max-width: 200px; max-height: 200px;">
              <br>
              Click here to view full size
            </a>
          </ng-container>
          <span *ngIf="associationMember.application_document === null" class="text-muted">None</span>
        </td>
      </tr>
      <tr>
        <td class="pr-3 align-text-top">Request Text:</td>
        <td>
          {{ associationMember.application_text }}
          <span *ngIf="associationMember.application_text === ''" class="text-muted">None</span>
        </td>
      </tr>
    </table>

    <div class="form-check mt-4">
      <input class="form-check-input" type="radio" id="approveInput"
             [value]="StaffApprovalAction.approve" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="approveInput">
        Approve request.
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" id="denyInput"
             [value]="StaffApprovalAction.deny" [(ngModel)]="selectedAction">
      <label class="form-check-label text-danger" for="denyInput">
        Deny request.
      </label>
    </div>
    <div class="form-check" *ngIf="showHideOption">
      <input class="form-check-input" type="radio" id="hideInput"
             [value]="StaffApprovalAction.hide" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="hideInput">
        Dismiss from inbox.
      </label>
    </div>

    <div class="alert alert-danger mb-0 mt-3" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-body" *ngIf="loadingAssociationMember">
    <p>Loading...</p>
  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!(loadingSubmit || loadingAssociationMember)"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit || loadingAssociationMember">
      Loading...
    </button>

  </div>

</ng-container>
